import { isNotFetched } from "@smartdevis/utils/src/async"
import { clientActions } from "../store"
import { mkResolver } from "./resolverUtils"

export const resolvePartners = mkResolver(
    s => s.data.partners,
    s => (isNotFetched(s.data.partners) ? [clientActions.fetchPartners()] : [])
)
